"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

exports.Card = utils_2.forwardRef(function Grid(props, ref) {
  var children = props.children,
      rest = __rest(props, ["children"]);

  var cardContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tborder-radius: 0.5rem;\n\t\tbackground: #ffffff;\n\t\tpadding: 0.5em;\n\t\tbox-shadow: 0 5px 10px rgba(66, 85, 99, 0.25);\n\t"], ["\n\t\twidth: 100%;\n\t\tborder-radius: 0.5rem;\n\t\tbackground: #ffffff;\n\t\tpadding: 0.5em;\n\t\tbox-shadow: 0 5px 10px rgba(66, 85, 99, 0.25);\n\t"])));
  return (0, _core.jsx)(lseds_1.lseds.div, _extends({
    ref: ref,
    css: cardContainer
  }, rest), children);
});

if (utils_1.isDev) {
  exports.Card.displayName = 'Card';
}

var templateObject_1;